import axios from 'axios'
import Utils from '@/common/Utils'
import store from '../store'

let defaultHeaders = { 'Content-Type': 'application/json' }

const url = `${process.env.VUE_APP_BASEPATH || ''}/api`

export default class GenericService {
    static async getAll (endpoint, params, confs = { }) {
        let baseUrl = url
        defaultHeaders['Authorization'] = await Utils.setLocalToken()

        // override default conf
        const { uri, headers } = confs
        if (uri) baseUrl = uri
        if (headers) defaultHeaders = { ...defaultHeaders, ...headers }

        try {
            let { data } = await axios.get(baseUrl + endpoint, { headers: defaultHeaders, params })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    }

    static async getOne (endpoint, id, params = {}) {
        try {
            defaultHeaders['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(url + `${endpoint}${id}`, { headers: defaultHeaders, params })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    }

    static async create (endpoint, obj) {
        try {
            defaultHeaders['Authorization'] = await Utils.setLocalToken()
            obj.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            obj.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.post(`${url}${endpoint}`, JSON.stringify(obj), { headers: defaultHeaders })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    }

    static async update (endpoint, obj = {}) {
        try {
            defaultHeaders['Authorization'] = await Utils.setLocalToken()
            obj.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            obj.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.put(`${url}${endpoint}${obj.id}`, JSON.stringify(obj), { headers: defaultHeaders })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    }

    static async executeAction (endpoint, actionData = {}) {
        try {
            defaultHeaders['Authorization'] = await Utils.setLocalToken()
            actionData.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            actionData.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.put(`${url}${endpoint}`, JSON.stringify(actionData), { headers: defaultHeaders })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    }

    static async downloadFile (endpoint, actionData = {}) {
        try {
            defaultHeaders['Authorization'] = await Utils.setLocalToken()
            actionData.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            actionData.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.put(`${url}${endpoint}`, JSON.stringify(actionData), { headers: defaultHeaders })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error.response)
        }
    }

    static async uploadFile (endpoint, actionData = {}) {
        try {
            actionData.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            actionData.userId = store.getters.user ? store.getters.user.userId : null

            const formData = new FormData()
            for (const key in actionData) {
                formData.append(key, actionData[key])
            }

            defaultHeaders['Authorization'] = await Utils.setLocalToken()

            let { data } = await axios.put(`${url}${endpoint}`, formData, { headers: { headers: defaultHeaders, 'Content-Type': 'multipart/form-data' } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }
}
